import type { CursorPage, MutationResult } from '../../api/contract';
import type { ApiDownload } from '../../api/http';
import { createRepositoryToken } from '../../data/RepositoryProvider';
import type {
  CreateReportExportInput,
  ReportExport,
  ReportExportDetail,
  ReportExportListQuery,
} from './types';

export interface ReportExportsRepository {
  list(query: ReportExportListQuery, signal: AbortSignal): Promise<CursorPage<ReportExport>>;
  create(
    input: CreateReportExportInput,
    idempotencyKey: string,
  ): Promise<MutationResult<ReportExport>>;
  get(exportId: string, signal: AbortSignal): Promise<ReportExportDetail>;
  download(exportId: string, signal: AbortSignal): Promise<ApiDownload>;
}

export const reportExportsRepositoryToken =
  createRepositoryToken<ReportExportsRepository>('reportExports');
